import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

function AboutFive(){
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div className="aboutFive">
            <div className="aboutFiveTitle">
                <h1 className={`${isVisible ? 'visible' : ''}`}>{t("about_five_title")}</h1>
            </div>
            <div className="aboutFiveText">
                <p className={`text1 ${isVisible ? 'visible' : ''}`}>
                    {t("about_five_text1")}
                </p>
                <p className={`text2 ${isVisible ? 'visible' : ''}`}>
                    {t("about_five_text2")}
                </p>
            </div>
            <div className="version">
                <p>{t("about_revision")}</p>
            </div>
        </div>
        </VisibilitySensor>
    )
}

export default AboutFive;